@if (datasetCode) {
  <div class="page-layout blank px-24 py-72" [class]="styleClassDataset" [ngClass]='pageClosureContainerService.templatePage.value' fusePerfectScrollbar>
    @switch (actionCode) {
      @case ("list") {
        <dataset-list [autoFetchData]='true' [datasetCode]='datasetCode' [filters]='sharedData && sharedData.filters'></dataset-list>
      }
      @case ("create") {
        <dataset-create [datasetCode]='datasetCode'></dataset-create>
      }
      @case ("detail") {
        <dataset-detail [datasetCode]='datasetCode' [inputRecord]='sharedData && sharedData.record'></dataset-detail>
      }
      @case ("edit") {
        <dataset-edit [datasetCode]='datasetCode' [inputRecord]='sharedData && sharedData.record'></dataset-edit>
      }
      @default {
        <div>
          <p>Unsupported action code "{{actionCode}}"</p>
        </div>
      }
    }
  </div>
}